export const detailsToastStyles = (theme) => ({
  toastContent: {
    maxWidth: 500,
    maxHeight: 250,
    overflowY: "auto",
    "& .MuiAccordionSummary-expandIcon": {
      transform: "none",
    },
  },
  expansionToggle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& > *": {
      color: theme.palette.common.white,
      fill: theme.palette.common.white,
    },
  },
  expansionDetails: {
    color: theme.palette.common.white,
  },
});
